var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"port_activity"},[_c('h2',{staticClass:"m-b-3 fz18 fw500 text-dark"},[_vm._v("Activity")]),_vm._l((_vm.activity),function(item){return _c('activity-item',{key:item.id,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }